import * as Notifications from 'expo-notifications';
import Constants from 'expo-constants';

import api from '../utils/api';


// A partir de expo44 `Expo.Constants.deviceId` valió madres....
// Entonces tuvimos que hacer nuestra propia imlementación
// https://stackoverflow.com/a/68553627 lo resuelve a medias
// peeero: (note that for iOS standalone apps, data stored with expo-secure-store can persist across app installs)
// import * as SecureStore from 'expo-secure-store';
// import 'react-native-get-random-values'; // este es dependencia de uuid
// import { v4 as uuidv4 } from 'uuid'; // Y este no sirve en android ya compilado


import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';


export function uuidv4() {
  let d = new Date().getTime();

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);

    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}


async function getDeviceUid() {
  let deviceUid = await AsyncStorage.getItem('@duid')

  if (!deviceUid) {
    deviceUid = uuidv4();

    await AsyncStorage.setItem('@duid', deviceUid)
  }

  return deviceUid
}


async function registerPushToken(){
  const deviceUid = await getDeviceUid()

  const { status: existingStatus } = await Notifications.getPermissionsAsync();;

  let finalStatus = existingStatus;

  // only ask if permissions have not already been determined, because
  // iOS won't necessarily prompt the user a second time.
  if (existingStatus !== 'granted') {
    // Android remote notification permissions are granted during the app
    // install, so this will only ask on iOS
    const { status } = await Notifications.requestPermissionsAsync();
    finalStatus = status;
  }

  // Stop here if the user did not grant permissions
  if (finalStatus !== 'granted') {
    console.log('No pudimos activar tus notificaciones push :( inalStatus !== granted');
    return;
  }

  let expoToken
  let tokenNative


  // On android 13+ The setNotificationChannelAsync must be called 
  // before getDevicePushTokenAsync or getExpoPushTokenAsync to obtain a push token.
  if (Platform.OS === 'android') {
    Notifications.setNotificationChannelAsync('default', {
      name: 'default',
      importance: Notifications.AndroidImportance.MAX,
      // vibrationPattern: [0, 250, 250, 250],
      // lightColor: '#FF231F7C',
    });
  }


  // Expo PushToken
  try {
    //! Calling getExpoPushTokenAsync without specifying a projectId is deprecated and will no longer be supported in SDK 49+
    expoToken = await Notifications.getExpoPushTokenAsync({
      projectId: Constants?.expoConfig?.extra?.eas.projectId
    });
  } catch (e) {
    console.log("[registerForPushNotificationsAsync] getExpoPushTokenAsync ERROR", e)
    return { error: "getExpoPushTokenAsync", data: e }
  }


  // Native PushToken
  try {
    tokenNative = await Notifications.getDevicePushTokenAsync();
  } catch (e) {
    console.log("[registerForPushNotificationsAsync] getDevicePushTokenAsync ERROR", e)

    return { error: "getDevicePushTokenAsync", data: e }
  }


  const deviceData = {
    ...Constants,
    appVersion: Constants.expoConfig?.version,
    systemFonts: [],

    // quitando variables innecesarias
    // manifest: {},
    expoConfig: {},
    manifest2:{
      ...Constants.manifest2,
      extra:{
        ...Constants.manifest2?.extra,
        expoClient: null,
      }
    }
  }

  const data = {
    expo_token: expoToken,
    push_token: tokenNative,
    device_uid: deviceUid,
    device_data: deviceData,
  }

  // POST the token to the API
  // console.log("registerForPushNotificationsAsync - registering", JSON.stringify(data))

  api.post(`/devices/push-token`, data)
    .then(response => {
      console.log("PUSH REGISTERED")
    })
    .catch(e => {
      console.log("PUSH REGISTRATION failed", e)
    })



  return { success: true, data }
}

/*
Uso:
const { registerPushToken } = useRegisterForPushNotifications()

useEffect(() => {
  registerPushToken()
}, []);
*/

//{"expo_token":{"type":"expo","data":"ExponentPushToken[kJfdw1OhJE6m6JltYZU5zh]"},"push_token":{"type":"android","data":"dQoCeCyUQtKTsVfmmVU8dT:APA91bGFt7zsV2DsBW1-SxuQbjpN-KG6q7BxXwYjD2ubYeuhwoabckWT04Cnj8z0Wa-FUZEVvSngPq9GG8JH5w3uY8mx1EYmTyCJ9wu3F3PZ0mcHBaA9xd1cWYa8sy_IvR3dWP0gCQ9C"},"device_uid":"38e90a09-7cff-47f9-b211-d5f80e772e38","device_data":{"statusBarHeight":37,"systemFonts":[],"isDevice":true,"nativeAppVersion":"2.29.1","expoVersion":"2.29.1","nativeBuildVersion":202,"executionEnvironment":"storeClient","linkingUri":"exp://192.168.1.69:19000","sessionId":"0e940f0f-c200-48cb-8563-e0de1884921b","supportedExpoSdks":["49.0.0","48.0.0","47.0.0"],"isDetached":false,"deviceName":"21121119SG","platform":{"android":{"versionCode":null}},"isHeadless":false,"intentUri":"exp://192.168.1.69:19000","systemVersion":"12","manifest":{},"experienceUrl":"exp://192.168.1.69:19000","appOwnership":"expo","manifest2":null,"expoConfig":{"owner":"ouvio","name":"DingDong","slug":"dingdong","scheme":"dingdong","version":"1.3.3","orientation":"portrait","userInterfaceStyle":"automatic","icon":"./assets/images/icon.png","splash":{"image":"./assets/images/splash.png","resizeMode":"contain","backgroundColor":"#ffffff","imageUrl":"http://192.168.1.69:19000/assets/./assets/images/splash.png"},"updates":{"fallbackToCacheTimeout":0},"assetBundlePatterns":["**/*"],"ios":{"supportsTablet":true},"android":{"adaptiveIcon":{"foregroundImage":"./assets/images/adaptive-icon.png","backgroundColor":"#37d1c4","foregroundImageUrl":"http://192.168.1.69:19000/assets/./assets/images/adaptive-icon.png"}},"web":{"favicon":"./assets/images/favicon.png"},"extra":{"API_URL":"https://ouvio-dev8001.ngrok.io/api"},"_internal":{"isDebug":false,"projectRoot":"/Users/pablomx/Development/dingdong/app","dynamicConfigPath":"/Users/pablomx/Development/dingdong/app/app.config.js","staticConfigPath":null,"packageJsonPath":"/Users/pablomx/Development/dingdong/app/package.json"},"sdkVersion":"48.0.0","platforms":["ios","android","web"],"iconUrl":"http://192.168.1.69:19000/assets/./assets/images/icon.png","debuggerHost":"192.168.1.69:19000","logUrl":"http://192.168.1.69:19000/logs","developer":{"tool":"expo-cli","projectRoot":"/Users/pablomx/Development/dingdong/app"},"packagerOpts":{"dev":true},"mainModuleName":"node_modules/expo/AppEntry","__flipperHack":"React Native packager is running","hostUri":"192.168.1.69:19000","bundleUrl":"http://192.168.1.69:19000/node_modules/expo/AppEntry.bundle?platform=android&dev=true&hot=false","id":"@ouvio/dingdong","isVerified":true},"appVersion":"1.3.3"}}

export default function useRegisterPushNotifications(params = {
    endpoint:`/devices/push-token`,
    experienceId:null,
}) {
  return {
    registerPushToken,
  }
}





// import * as Notifications from 'expo-notifications';
// import { useEffect } from 'react';

// function useRegisterPushNotifications(){
//   // recibir push notifications
//   // esta mejor alg tipo https://medium.com/cybermonkey/deep-linking-push-notifications-with-react-navigation-5fce260ccca2
//   useEffect(() => {
//     const _handleNotification = notification => {
//       console.log("handleNotification", notification.request.content)

//       if (notification.request.content?.data?.path) {
//         const url = Linking.createURL(notification.request.content?.data?.path)
//         Linking.openURL(url)
//       }
//     };

//     const _handleNotificationResponse = response => {
//       console.log("_handleNotificationResponse", response.notification.request.content)

//       if (response.notification.request.content?.data?.path) {
//         const url = Linking.createURL(response.notification.request.content.data.path)

//         setTimeout(() => {
//           Linking.openURL(url)
//         }, 800)
//       }
//     };

//     Notifications.addNotificationReceivedListener(_handleNotification);

//     Notifications.addNotificationResponseReceivedListener(_handleNotificationResponse);
//   }, [])
// }